export default "__VITE_ASSET__CQbDc5DD__"